const aivGuideData = {
  id: "aiveronica",
  title: "AIVeronica",
  category: "Live Ops",
  slug: "events/aiveronica",
  sections: [
    {
      id: "home",
      title: "Home",
      type: "section",
      content: [
        {
          type: "subdivision",
          title: "AIVeronica Guide",
          content: [
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/Guide+Images/aiveronica.jpeg",
                alt: "AIVeronica Guide",
              },
            },
            {
              type: "text",
              data: `Welcome to the AIVeronica Guide. I will provide as much info as I can for this 2 weeks Live Ops Event!!`,
            },
          ],
        },
      ],
    },
    {
      id: "summary",
      title: "Summary",
      type: "section",
      content: [
        {
          title: "Summary",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `AIVeronica is an AI Event added to the Pixels game introducing 3 Bachelors and 3 Bachelorettes.<br/>
              The goal is to make each one happy and get over 80pts on the AI before 10 minutes is up.<br/>
              You can do as many different ones as you can a day, but you can't redo the same one in the same day.`,
            },
            {
              type: "text",
              data: `Buy a Pass from Jeeves (see Key/Pass for more info)<br/>
                <i>Buying a Pass from Jeeves will give you 100 Reputation</i><br/>
                Once you've gotten a pass, select the pass and click on any of the doors. Choose one you like! The leaderboard depends on time, not which NPC you speak to, nor your score.<br/>
                Even if you have the best score, it won't matter if you don't have the best time! So go FAAAAST!<br/>
                <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-08_200752410.png" alt="Rooms" width="1000px"/>`,
            },
          ],
        },
      ],
    },
    {
      id: "howtoplay",
      title: "How To Play",
      type: "section",
      content: [
        {
          title: "How to Play",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `Every time you enter a room, you lose 1 key. So you need to buy 1 key per room you enter.<br/>
                Once you enter the room, open the chat box by clicking the Chat Button or pressing C.<br/>
                Say "Hello" or your best opening line for the NPC you've chosen!<br/>
                Once the NPC starts talking back, it'll show up with points for each chat line you offer.`,
            },
            {
              type: "text",
              data: `You have 10 minutes to score 80 points. If you fail, the NPC will stop talking to you, and you'll have to try again another day (yes, you'll need to buy a new key).`,
            },
            {
              type: "text",
              data: `Chat with the NPC like you're trying to become their best friend (you may need to be really fake depending on which personality you're trying to please)`,
            },
            {
              type: "image",
              data: {
                img: `https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-08_225708237.png`,
                alt: "Introduction with Vynn",
              },
            },
            {
              type: "text",
              data: `You will see points add up over the duration of the conversation`,
            },
            {
              type: "image",
              data: {
                img: `https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-09_000307210.png`,
                alt: "Introduction with Vynn",
              },
            },
            {
              type: "text",
              data: `Be careful with what words you use. Sometimes you can be deducted points for saying something graphic, using foul language, saying anything bad, or ... you know `,
            },
            {
              type: "image",
              data: {
                img: `https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-09_010847967.png`,
                alt: "Foul Language with Vynn",
              },
            },
            {
              type: "text",
              data: `When you've hit over 80 points, the NPC will give you their closing statement, and let you know they've enjoyed their time with you!`,
            },
            {
              type: "image",
              data: {
                img: `https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-08_220801791.png`,
                alt: "Vynn Final Dialog",
              },
            },
            {
              type: "text",
              data: `The NPC will then send a trade ren. Accept it! He will give you his portrait, and a blanket with his face on them. (Don't worry about my fee there ╰(￣ω￣ｏ)`,
            },
            {
              type: "image",
              data: {
                img: `https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-08_220848023.png`,
                alt: "Vynn Prize",
              },
            },
          ],
        },
      ],
    },
    {
      id: "key",
      title: "Key/Pass",
      type: "section",
      content: [
        {
          title: "How to get the key",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `You can buy the key from Jeeves within the game, or at a discount from the <a href="https://aiveronica.ai/whitelist" target="_blank" rel="noreferrer" class="wiki-links">AI Veronica whitelist website</a>.<br/>
                You can only buy 1 key per day from the game (resets at 12AM UTC) and one key from the Whitelist site per day. The whitelist key is sent to your mailbox the following day (repeating what I saw in the chat!)`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-08_200453399.png",
                alt: "Jeeves",
              },
            },
          ],
        },
      ],
    },
    {
      id: "ais",
      title: "AIs",
      type: "section",
      content: [
        {
          title: "Sakura",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `<b>Gender:</b>: Female <br/>
              <b>Persona:</b> She is a smart girl<br/>
              <b>Likes:</b> Into Medical things like health, medical journals, caring for health, and self-uplliftment. Being a surgeon excites her, but she isn't one. She does get excited when the topic is brought up. <br/>`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-09_000857963.png",
                alt: "Sakura",
              },
            },
            {
              type: "inlineLink",
              data: {
                text: ["Sakura Portrait", "Sakura Blanket"],
                itemId: ["itm_waifuPortrait1", "itm_bedcovers_09"],
                description: `The prizes she gives are the Sakura Portrait and the Sakura Blanket!`,
              },
            },
          ],
        },
        {
          title: "Diane",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `<b>Gender:</b>: Female <br/>
                  <b>Persona:</b> The artistic type<br/>
                  <b>Likes:</b> Try discussing philosophical, artistic questions. Ponder about life. She is cute and likes having deeper conversations. She also talks about reading<br/>`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-09_000916188.png",
                alt: "Diane",
              },
            },
            {
              type: "inlineLink",
              data: {
                text: ["Diane Portrait", "Diane Blanket"],
                itemId: ["itm_waifuPortrait3", "itm_bedcovers_12"],
                description: `The prizes she gives are the Diane Portrait and the Diane Blanket!`,
              },
            },
          ],
        },
        {
          title: "Avril",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `<b>Gender:</b>: Female <br/>
                  <b>Persona:</b> She's a Rocker<br/>
                  <b>Likes:</b> She likes rock music, rock concerts, and rock bands! Bring your best rock knowledge, but bring more emo and punk rock vibes. <br/>`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-09_000909194.png",
                alt: "Avril",
              },
            },
            {
              type: "inlineLink",
              data: {
                text: ["Avril Portrait", "Avril Blanket"],
                itemId: ["itm_waifuPortrait4", "itm_bedcovers_11"],
                description: `The prizes she gives are the Avril Portrait and the Avril Blanket!`,
              },
            },
          ],
        },
        {
          title: "Zane",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `<b>Gender:</b>: Male <br/>
                  <b>Persona:</b> He's a bad boy type <br/>
                  <b>Likes:</b> He enjoys drinking, likes talking about combat sports, strategy games, and swords. He likes talking about being challenged <br/>`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-09_000937905.png",
                alt: "Zane",
              },
            },
            {
              type: "inlineLink",
              data: {
                text: ["Zane Portrait", "Zane Blanket"],
                itemId: ["itm_waifuPortrait6", "itm_bedcovers_14"],
                description: `The prizes he gives are the Zane Portrait and the Zane Blanket!`,
              },
            },
          ],
        },
        {
          title: "Noa",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `<b>Gender:</b>: Male <br/>
                  <b>Persona:</b> He's whimsical<br/>
                  <b>Likes:</b> Enjoys literature and poetry, soft music, instruments (probably piano or something elegant), seems gentle and calming. Doesn't like exciting conversations<br/>`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-09_000922510.png",
                alt: "Noa",
              },
            },
            {
              type: "inlineLink",
              data: {
                text: ["Noa Portrait", "Noa Blanket"],
                itemId: ["itm_waifuPortrait2", "itm_bedcovers_10"],
                description: `The prizes he gives are the Noa Portrait and the Noa Blanket!`,
              },
            },
          ],
        },
        {
          title: "Vyn",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `<b>Gender:</b>: Male <br/>
                  <b>Persona:</b> He's the dark, brooding type<br/>
                  <b>Likes:</b> He is into magical stuff like gothic things, tragedy, he's a little dark and brooding but not TOO dark. Dark tales, enchanting shadows and moonlight.<br/>`,
            },
            {
              type: "image",
              data: {
                img: "https://pixelore.s3.eu-central-003.backblazeb2.com/LiveOps/AIVeronica/image_2025-05-09_000931116.png",
                alt: "Vyn",
              },
            },
            {
              type: "inlineLink",
              data: {
                text: ["Vyn Portrait", "Vyn Blanket"],
                itemId: ["itm_waifuPortrait5", "itm_bedcovers_13"],
                description: `The prizes he gives are the Vyn Portrait and the Vyn Blanket!`,
              },
            },
          ],
        },
      ],
    },
    {
      id: "prizes",
      title: "Prizes",
      type: "section",
      content: [
        {
          title: "What are the Prizes?",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `For every character you rizz up, you will get a portrait of their character, and a blanket with their face on it!`,
            },
            { type: "text", data: `Purchasing a key in-game grants 100 Reputation Points!` },
            {
              type: "text",
              data: `Top 500 Players will receive $AIV Airdrop from AIVeronica - you can see the leaderboard <a href="https://aiveronica.ai/leaderboard" target="_blank" rel="noreferrer" class="wiki-links">here</a>.<br/>
                <br/>
                Top 500 Players with the best time of completing their 80 score will also get a share of the $PIXEL spent on this event!
                <br/>Top 10 Players will get 1% of the share
                <br/>Top 11 - 100 Players will get 0.3% of the share
                <br/>Top 101 - 500 Players will get 0.2% of the share
                
                <br/><br/>The exact amount of $PIXEL will depend on how many players actually play the event!`,
            },
          ],
        },
      ],
    },
  ],
};

export default aivGuideData;
